/** Optional PostHog — only loads when REACT_APP_POSTHOG_KEY is set. */
export function initPostHog() {
    const key = process.env.REACT_APP_POSTHOG_KEY?.trim();
    if (!key || typeof window === "undefined") return;

    const host = process.env.REACT_APP_POSTHOG_HOST?.trim() || "https://us.i.posthog.com";

    if (window.posthog?.__loaded) return;

    !(function (t, e) {
        var o, n, p, r;
        e.__SV ||
            ((window.posthog = e),
            (e._i = []),
            (e.init = function (i, s, a) {
                function g(t, ev) {
                    var o = ev.split(".");
                    2 == o.length && ((t = t[o[0]]), (ev = o[1])),
                        (t[ev] = function () {
                            t.push([ev].concat(Array.prototype.slice.call(arguments, 0)));
                        });
                }
                ((p = t.createElement("script")).type = "text/javascript"),
                    (p.crossOrigin = "anonymous"),
                    (p.async = !0),
                    (p.src =
                        s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
                        "/static/array.js"),
                    (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
                var u = e;
                for (
                    void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                        u.people = u.people || [],
                        u.toString = function (t) {
                            var ev = "posthog";
                            return "posthog" !== a && (ev += "." + a), t || (ev += " (stub)"), ev;
                        },
                        u.people.toString = function () {
                            return u.toString(1) + ".people (stub)";
                        },
                        o =
                            "init capture register register_once unregister identify reset group".split(
                                " ",
                            ),
                        n = 0;
                    n < o.length;
                    n++
                )
                    g(u, o[n]);
                e._i.push([i, s, a]);
            }),
            (e.__SV = 1));
    })(document, window.posthog || []);

    window.posthog.init(key, {
        api_host: host,
        person_profiles: "identified_only",
        session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
    });
    window.posthog.__loaded = true;
}
